<!-- Loader -->
@if (loader) {
  <div>
    <div id="global-loader">
      <img src="./assets/img/loader.svg" class="loader-img" alt="Loader">
    </div>
  </div>
}
<!-- /Loader -->
